import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, GasoilConsumptionPriceSource, CalculationMethodType } from "__generated__/graphql";

export const GasolinePriceSchema: RegistryItem = {
	[AgreementTypeEnum.GasolinePrice]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.GasoilConsumption,
				priceSource: GasoilConsumptionPriceSource.Manual,
			},
		},
		agreementFields: {
			"agreement.conditions": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
		},
	},
};
